// Utilidades para manejo seguro de cookies
const TOKEN_COOKIE_NAME = 'auth_token';
const USER_COOKIE_NAME = 'user_data';

// Opciones de seguridad para las cookies
const getCookieOptions = (isSecure = true) => {
  const options = {
    path: '/',
    sameSite: 'strict',
    maxAge: 7 * 24 * 60 * 60, // 7 días en segundos
  };
  
  // En producción, usar HTTPS y dominio específico
  if (isSecure && window.location.protocol === 'https:') {
    options.secure = true;
  }
  
  return options;
};

// Función para establecer una cookie
const setCookie = (name, value, options = {}) => {
  const cookieOptions = { ...getCookieOptions(), ...options };
  
  let cookieString = `${name}=${encodeURIComponent(value)}`;
  
  if (cookieOptions.path) cookieString += `; path=${cookieOptions.path}`;
  if (cookieOptions.maxAge) cookieString += `; max-age=${cookieOptions.maxAge}`;
  if (cookieOptions.sameSite) cookieString += `; samesite=${cookieOptions.sameSite}`;
  if (cookieOptions.secure) cookieString += '; secure';
  if (cookieOptions.httpOnly) cookieString += '; httponly';
  
  document.cookie = cookieString;
};

// Función para obtener una cookie
const getCookie = (name) => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) {
      return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
  }
  return null;
};

// Función para eliminar una cookie
const removeCookie = (name) => {
  document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; samesite=strict`;
};

export const cookieUtils = {
  // Token management
  setToken: (token) => setCookie(TOKEN_COOKIE_NAME, token),
  getToken: () => getCookie(TOKEN_COOKIE_NAME),
  removeToken: () => removeCookie(TOKEN_COOKIE_NAME),
  
  // User data management (solo campos esenciales: las cookies tienen ~4KB)
  setUser: (user) => {
    if (!user || typeof user !== 'object') {
      removeCookie(USER_COOKIE_NAME);
      return;
    }
    const slimUser = {
      cedula: user.cedula ?? user.Cedula ?? null,
      name: user.name ?? user.Name ?? user.user ?? null,
      user: user.user ?? user.name ?? user.Name ?? null,
      email: user.email ?? user.Email ?? null,
      rol: user.rol ?? user.role ?? user.Role ?? null,
      role: user.role ?? user.rol ?? user.Role ?? null,
      roleId: user.roleId ?? user.RoleId ?? null,
      authSource: user.authSource ?? null,
      id: user.id ?? user.Id ?? null,
    };
    setCookie(USER_COOKIE_NAME, JSON.stringify(slimUser));
  },
  getUser: () => {
    const userData = getCookie(USER_COOKIE_NAME);
    if (!userData) return null;
    try {
      return JSON.parse(userData);
    } catch (error) {
      console.error('Cookie de usuario corrupta, se limpia:', error);
      removeCookie(USER_COOKIE_NAME);
      return null;
    }
  },
  removeUser: () => removeCookie(USER_COOKIE_NAME),
  
  // Utility functions
  setCookie,
  getCookie,
  removeCookie,
  
  // Check if token is expired (JWT usa base64url: - y _)
  isTokenExpired: (token) => {
    if (!token) return true;
    try {
      const segment = token.split('.')[1];
      if (!segment) return true;
      const base64 = segment.replace(/-/g, '+').replace(/_/g, '/');
      const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
      const payload = JSON.parse(atob(padded));
      // Tokens permanentes (.NET) pueden no traer exp
      if (payload.exp == null) return false;
      return payload.exp * 1000 < Date.now();
    } catch {
      return true;
    }
  },
  
  // Clear all auth cookies
  clearAuth: () => {
    removeCookie(TOKEN_COOKIE_NAME);
    removeCookie(USER_COOKIE_NAME);
  }
}; 